/* eslint-disable import/order */
import { projectNotFoundEntryPoint } from '@jira/spa-apps__project-not-found/src/projectNotFoundEntryPoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectNotFoundRoute } from '@jira/router-routes__project-not-found-routes/src/projectNotFoundRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';

const projectNotFoundPageEntryPoint = createPageEntryPoint({
	main: projectNotFoundEntryPoint,
});

export const projectNotFoundRouteEntry: Route = createEntry(projectNotFoundRoute, () => ({
	group: 'errors',

	entryPoint() {
		return projectNotFoundPageEntryPoint;
	},

	layout: globalLayout,
	resources: [...getNavigationResources()],
	pageId: 'project-not-found-page-id',

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
